import React from 'react'

// Which component of the compound the reader is currently pointing at, shared
// between the Components list (the hover source) and the hero headword (which
// tints that chunk's background in response). null = nothing hovered.
type PartHoverValue = {
   hoveredPart: number | null
   setHoveredPart: (index: number | null) => void
}

const PartHoverContext = React.createContext<PartHoverValue>({
   hoveredPart: null,
   setHoveredPart: () => {},
})

export const PartHoverProvider = ({ children }: { children: React.ReactNode }) => {
   const [hoveredPart, setHoveredPart] = React.useState<number | null>(null)

   const value = React.useMemo(() => ({ hoveredPart, setHoveredPart }), [hoveredPart])

   return <PartHoverContext.Provider value={value}>{children}</PartHoverContext.Provider>
}

export const usePartHover = (): PartHoverValue => React.useContext(PartHoverContext)
